import { AxiosResponse } from "axios"

import { request } from "../../request"
import { VehicleDetailsWithImage } from "./types"

export const requestData = {
  capImageProperties: {
    width: 860,
    height: 600,
  },
}

export const getVehicleDetailsWithImageRequest = async (
  registration: string
): Promise<AxiosResponse<VehicleDetailsWithImage.RootObject>> => {
  const regNumber = registration.replace(/\s/g, "")

  return request({
    url: `/api/v1/hpi-cap/vrms/${regNumber}/basic-inc-image`,
    method: "post",
    headers: {
      "Access-Control-Request-Methods": "*",
      "Access-Control-Allow-Origin": "*",
    },
    data: requestData,
  })
}
